import React, { useState } from 'react';

const Skills = () => {
    const [active,setActive] = useState(false)
    const activeSkills=()=>{
        const scrollValue = document.documentElement.scrollTop;
        if(scrollValue>1100){
            setActive(true)
        }
        else{
            setActive(false)
        }

    }
    window.addEventListener('scroll',activeSkills)
    
    return (
        <div id='skills' className={active?'block':'hidden'}>
            <h1 className='text-center my-10 text-4xl font-bold text-white mt-32'>My <span className='text-neutral' >Skills</span></h1>

            <div className="flex flex-col lg:flex-row gap-40">

                {/* frontend skills  */}
                <div className="basis-1/2">
                    <h1 className=' skHead text-2xl text-white border-b-2 font-bold'>FrontEnd</h1>
                    <div className='my-8'>
                        <div class="my-3 text-xl font-medium text-white">HTML</div>
                        <div class="w-full bg-gray-200  h-2.5">
                            <div class=" h-2.5  loading-bar" style={{ width: '90%' }}></div>
                        </div>

                        <div class="my-3 text-xl font-medium text-white">CSS</div>
                        <div class="w-full bg-gray-200  h-2.5">
                            <div class=" h-2.5  loading-bar" style={{ width: '85%' }}></div>
                        </div>

                        <div class="my-3 text-xl font-medium text-white">JavaScript</div>
                        <div class="w-full bg-gray-200  h-2.5">
                            <div class=" h-2.5  loading-bar" style={{ width: '80%' }}></div>
                        </div>

                        <div class="my-3 text-xl font-medium text-white">React JS</div>
                        <div class="w-full bg-gray-200  h-2.5">
                            <div class=" h-2.5  loading-bar" style={{ width: '75%' }}></div>
                        </div>

                        <div class="my-3 text-xl font-medium text-white">Tailwind</div>
                        <div class="w-full bg-gray-200  h-2.5">
                            <div class=" h-2.5  loading-bar" style={{ width: '70%' }}></div>
                        </div>
                    </div>
                </div>

                {/* backend skills  */}
                <div className="basis-1/2">
                <h1 className='skHead text-2xl text-white border-b-2 font-bold'>Backend</h1>
                    <div className='my-8'>

                    <div class="my-3 text-xl font-medium text-white">MongoDB</div>
                        <div class="w-full bg-gray-200  h-2.5">
                            <div class=" h-2.5  loading-bar" style={{ width: '85%' }}></div>
                        </div>


                        <div class="my-3 text-xl font-medium text-white">NodeJS</div>
                        <div class="w-full bg-gray-200  h-2.5">
                            <div class=" h-2.5  loading-bar" style={{ width: '80%' }}></div>
                        </div>

                        <div class="my-3 text-xl font-medium text-white">Express JS</div>
                        <div class="w-full bg-gray-200  h-2.5">
                            <div class=" h-2.5  loading-bar" style={{ width: '70%' }}></div>
                        </div>

                        

                        <div class="my-3 text-xl font-medium text-white">FairBase</div>
                        <div class="w-full bg-gray-200  h-2.5">
                            <div class=" h-2.5  loading-bar" style={{ width: '65%' }}></div>
                        </div>

                        <div class="my-3 text-xl font-medium text-white">JWT</div>
                        <div class="w-full bg-gray-200  h-2.5">
                            <div class=" h-2.5  loading-bar" style={{ width: '60%' }}></div>
                        </div>
                    </div>

                </div>


            </div>


        </div>
    );
};

export default Skills;